var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 361,
    height: 231,
    fill: "none",
    viewBox: "0 0 361 231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4F1",
    d: "M22.186 146.687S-34.188 97.298 36.87 73.951c35.435-11.64 43.77-17.621 71.302-40.15 39.406-32.254 91.054-50.895 158.197 5.97 67.142 56.865 117.812 74.502 73.607 108.596-49.689 38.325-19.461 58.032-25.692 68.836-1.658 2.874-12.16-9.417-35.287 3.238-52.674 28.823-79.481-15.027-118.218-4.09-36.536 10.317-55.309-12.502-67.202-3.58-17.736 13.313-28.833 13.142-35.499 9.64-5.576-2.937-8.859-9-8.602-15.354.294-7.219.346-20.74-2.565-30.581-4.402-14.874-15.112-22.48-24.726-29.789z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F4F1",
    d: "M22.814 147.285S-34.098 96.822 37.632 72.97c35.759-11.896 44.176-18.005 71.957-41.028 39.777-32.957 91.894-52.002 159.65 6.1C336.994 96.147 389.784 116.486 343.526 149c-32.034 22.518-21.19 11.525-31.168 19.243-21.19 16.357-69.384-14.376-108.481-3.201-36.875 10.539-72.745-5.205-88.768-6.272-6.349-.416-31.97-.513-44.878-1.204-7.223-.372-15.186 2.777-25.194.401-15.082-3.58-12.524-3.208-22.223-10.681z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEB59B",
    d: "M83.971 53.467L65.495 65.903c-.242.145-.67-2.48-.93-2.368l-12.58 4.833-.145 90.312 78.638-.967-.599-122.403-23.915.22-21.993 17.937z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M77.882 56.404l-19.246 9.432-.048 2.52 64.139-.371-.257-23.087-27.659-.372-6.2 4.744c-1.086.822-2.413 1.695-4.09 2.81-2.78 1.84-4.46 3.071-6.64 4.324zM58.621 72.137v22.8l64.198-.13.004-22.67H58.621zM58.8 99v22.805l64.194-.13.004-22.674H58.8zM59.153 126.258v22.804l64.194-.13.004-22.674H59.153z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.96 111.96l3.011-3.94 11.186 9.963-2.8 4.056L80.96 111.96zM58.781 103.451l7.242.041.056 18.357-7.287-.089-.011-18.309z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M74.625 106.577l2.952-1.687 7.569 15.108-2.952 1.989-7.569-15.41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.123 101.451h3.52l.09 20.465-3.617-.093.007-20.372z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M66.071 107.693l5.13.093-.085 14.082-5.134-.078.09-14.097z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.15 103.399l7.241.041.053 18.357-7.283-.089-.011-18.309zM106.492 101.399h3.517l.089 20.465-3.613-.093.007-20.372z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M101.44 107.644l5.13.089-.085 14.086-5.138-.081.093-14.094z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.157 128.158l5.528.048.04 21.046-5.561-.104-.008-20.99z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M64.703 131.333l3.744-.048-.134 17.87-3.7-.004.09-17.818z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.447 135.01l5.074.067-.082 14.086-5.137-.082.145-14.071z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M99.648 65.308v2.62l20.539.146v-2.766H99.648z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.618 63.23l.097 2.096 13.361.097-.09-2.29-13.368.097zM58.662 76.558l7.242.044.056 18.358-7.283-.093-.015-18.31z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M115.05 79.502l-3.052-1.692-7.815 15.112 3.049 1.986 7.818-15.406z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.381 74.368h3.516l.09 20.462-3.614-.09.008-20.372z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M114.548 80.729l5.13.089-.085 14.086-5.134-.082.089-14.093zM79.993 92.257v2.62l20.54.146v-2.766h-20.54z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.216 90.112l.1 2.093 13.362.097-.09-2.287-13.371.097z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5FC",
    d: "M278.112 184.837s-6.171 7.279-1.115 7.48c5.056.201 15.428 6.067 17.413.811 1.985-5.257 5.948-7.886 3.528-8.492-2.42-.605-4.628-3.033-9.699-2.628-5.071.405-10.127 2.829-10.127 2.829z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEB59B",
    d: "M276.499 149.401s-2.892.312-2.892 3.892 1.858 34.622 8.922 35.232c4.591.398 9.45.372 11.851.141 1.038-.1 2.056-3.234 2.231-4.49.933-6.168 2.134-21.191 2.398-29.942.052-1.766-1.164-4.134-1.8-4.714-3.509-3.205-20.71-.119-20.71-.119z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4A089",
    d: "M310.678 89.394c-1.115-1.037-2.669.372-2.078 1.837.561 1.401.952 3.837-1.297 6.446-3.491 4.049-16.082 17.73-15.956 26.526.126 8.795-2.602 11.249 0 14.599 2.602 3.349 13.089 3.215 15.833-3.904 2.743-7.119 9.703-9.997 9.569-20.183-.134-10.186-1.353-14.662-2.602-18.15-.774-2.211-2.008-5.802-3.469-7.17z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.886,
    d: "M291.603 148.081s1.116-15.945 13.577-22.886c7.807-4.349 8.335-19.447 6.468-22.859"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M293.202 154.776s3.926 15.696-.327 28.124zM302.176 85.922c-1.186-.992-2.859.346-2.23 1.755.602 1.342 1.018 3.67-1.391 6.164-3.74 3.874-17.227 16.96-17.101 25.373.127 8.413 0 13.353 2.803 16.558 2.804 3.204 9.294.632 12.22-6.179s12.335-9.71 12.201-19.462c-.134-9.751-1.45-14.023-2.784-17.361-.829-2.104-2.157-5.54-3.718-6.848z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.886,
    d: "M286.399 148.408s-4.387-21.692 6.294-34.711c4.271-5.205 10.606-15.66 10.55-20.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4A089",
    d: "M268.889 89.394c1.097-1.037 2.647.372 2.063 1.837-.557 1.401-.944 3.837 1.287 6.446 3.461 4.049 15.948 17.73 15.825 26.526-.122 8.795 0 13.959-2.602 17.313-2.602 3.353-8.591.661-11.313-6.458-2.721-7.119-11.412-10.157-11.305-20.343.108-10.186 1.342-14.662 2.58-18.15.796-2.211 2.019-5.802 3.465-7.17z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.886,
    d: "M282.919 148.802s5.026-19.703-4.862-32.715c-3.956-5.205-10.291-12.922-10.238-17.963"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M260.87 123.753s-10.331.238-15.907-12.313c-5.576-12.55 6.97-15.082 16.223-8.365 9.253 6.718 5.45 9.506 16.477 15.719 11.026 6.212 8.621 18.506 5.204 21.8-3.416 3.294-9.885 8.364-14.197-4.945-4.312-13.309-7.8-11.896-7.8-11.896z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.886,
    d: "M280.938 148.958s.743-31.365-30.376-40.009"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M276.499 149.401s12.666-2.038 17.614-.971c4.948 1.067-8.729 2.328-8.729 2.328s-6.517.29-8.885-1.357z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4A089",
    d: "M122.834 152.717s-14.275-11.261-16.688-22.306c-2.412-11.045 2.814-18.7 10.454-19.904 7.64-1.205 12.268-4.833 39.004 4.223 26.737 9.056 57.503-7.037 57.503-7.037s25.142-11.566 37.548-8.744c14.126 3.208 17.13 11.759 13.312 27.042-3.818 15.283-16.825 26.841-16.825 26.841l-124.308-.115z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4A089",
    d: "M116.373 151.52s-2.23 0-2.602 2.23c-.372 2.231.372 9.295 1.487 11.525 1.115 2.231 6.346 2.119 6.346 2.119l127.485-.26s4.235.045 5.205-3.346c.777-2.725 1.911-5.443 1.993-7.324.047-1.069-.304-2.119-.987-2.943-.683-.825-1.649-1.366-2.709-1.518-1.384-.17-2.776-.262-4.171-.275-9.669-.004-132.047-.208-132.047-.208z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.425 186.094l8.55-18.588h6.692l-8.922 18.588h-6.32zM242.026 167.506l7.807 18.96 5.576-.372-7.435-18.588h-5.948z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M125.002 151.721s-11.752-9.068-12.302-12.841c-.717-4.889 3.718-12.194 20.9-8.96 17.183 3.235 47.481 11.986 63.901 7.506 16.421-4.479 37.09-23.209 38.577-24.198 1.487-.989 19.056-9.643 23.049 3.543 3.993 13.187-12.06 34.808-12.06 34.808l-122.065.142zM182.155.577l.487 25.175.591-.107.524-25.068h-1.602z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF8E7A",
    d: "M169.393 46.378s-4.684-21.023 13.851-21.224c17.536-.19 13.038 22.306 13.038 22.306l-26.889-1.082z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169.229 46.382s14.915-6.458 27.097.996c0 0-12.821 6.822-27.097-.996zM176.445 28.912s-6.502 2.424-5.178 13.443z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M169.226 46.382l-13.153 47.321 53.822-.528-13.572-45.797-27.097-.996z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 182.887,
    x2: 182.999,
    y1: 20.867,
    y2: 103.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustration);
export default __webpack_public_path__ + "static/media/home-illustration.ef86b80ce7fdd35351d6dfd39d6fc467.svg";
export { ForwardRef as ReactComponent };